@if (refresh$ | async){
  <p-toolbar styleClass="mt-6 p-10">
    <ng-template #start>

      <!-- @if (awaitingRefresh()){ -->
        <p-tag [severity]="awaitingRefresh()? 'danger' : 'success'">
          {{awaitingRefresh() && !isLoading() &&!pendingSave() ?  'New data coming from server, local data may be out of date.' : 'Data Synched with Server'}}
        </p-tag>
        <!-- @if (pendingSave()){
          <p-tag [severity]="'warn'">
            Table was edited, pending save changes
          </p-tag>
        } -->

      <!-- } -->
    </ng-template>
    <ng-template #end>
      @if(isLoading()){
        <p-progress-spinner ariaLabel="loading" strokeWidth="5"  [style]="{ width: '30px', height: '30px' }"/>
    }
      @else if (awaitingRefresh()){
        <p-button [severity]="'success'" (onClick)="getNew()"  icon="pi pi-cloud-download" [rounded]="true" class="transition duration-300 ease-in-out hover:-translate-y-1 hover:scale-110 "/>
      }
      <span class="font-semibold"> </span>
    </ng-template>
  </p-toolbar>
}

<div class="card flex justify-end pt-8 pb-8">
  <p-toggleswitch [ngModel]="topicsActive()" (onChange)="changeTopicsStatus()">
    <ng-template #handle let-checked="checked">
      <i [ngClass]="['!text-xs', 'pi', checked ? 'pi-check' : 'pi-times']"></i>
  </ng-template>
    </p-toggleswitch>
  <!-- <p-togglebutton [ngModel]="!topicsActive()" onLabel="Inactive" offLabel="Active" offIcon="pi pi-lock-open" styleClass="w-36" ariaLabel="Do you confirm" /> -->
</div>

@if (getTables$ | async){
<div class="card">
  <p-toast
    [showTransformOptions]="'translateY(100%)'"
    [showTransitionOptions]="'1000ms'"
    [hideTransitionOptions]="'1000ms'"
    [showTransformOptions]="'translateX(100%)'"
  />
  <p-table
    editMode="row"
    [rowHover]="true"
    [value]="topicClassificationTableIncoming()"
    dataKey="topic"
    [(selection)]="selectedTopics"
    [tableStyle]="{ 'min-width': '100%' }"
    [ngClass]="{
      'active-table': topicsActive(),
      'inactive-table': !topicsActive()
    }"
  >
    <ng-template #header>
      <tr>

        <th style="width: 30%; max-width: 30%; color:#5861ff;" class="text-xl">Topic</th>
        <th style="width: 30%; max-width: 30%; color:#5861ff;" class="text-xl">
          Definition (English)
        </th>
        <th style="width: 30%; max-width: 30%; color:#5861ff;" class="text-xl">
          Definition (Greek)
        </th>
        <th style="width: 5%; color:#fffffe;" class="text-xl">Edit</th>
        <th style="width: 5%; max-width: 10%"><p-tableHeaderCheckbox /></th>
      </tr>
    </ng-template>
    <ng-template
      #body
      let-topic
      let-rowIndex="rowIndex"
      let-rowgroup="rowgroup"
      let-rowspan="rowspan"
      let-editing="editing"
    >
      <tr [pEditableRow]="topic" 
          [ngClass]="{ 
            'row-changed': isRowChanged(topic.topic), 
            'row-added': isRowAdded(topic.topic) 
          }">
        <td [ngClass]="{ 
              'row-changed': isRowChanged(topic.topic), 
              'row-added': isRowAdded(topic.topic) 
            }">
          <span
          class="font-semibold"
          >{{ topic.topic }}</span
        >
        </td>
        <td [ngClass]="{ 
              'row-changed': isRowChanged(topic.topic), 
              'row-added': isRowAdded(topic.topic) 
            }">
          <p-cellEditor>
            <ng-template #input>
              <textarea
                pTextarea
                fluid
                cols="20"
                rows="4"
                required
                [(ngModel)]="topic.en_definition"
              ></textarea>
            </ng-template>
            <ng-template #output>
              <span class="text-sm">{{
                topic.en_definition
              }}</span>
            </ng-template>
          </p-cellEditor>
        </td>
        <td [ngClass]="{ 
              'row-changed': isRowChanged(topic.topic), 
              'row-added': isRowAdded(topic.topic) 
            }">
          <p-cellEditor>
            <ng-template #input class="text-sm">
              <textarea
                pTextarea
                fluid
                cols="20"
                rows="10"
                [(ngModel)]="topic.gr_definition"
              ></textarea>
            </ng-template>
            <ng-template #output>
              <span class="text-sm">
                {{ topic.gr_definition }}</span
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td>
          @if (topicsActive()){
            <div class="flex items-center justify-center gap-2">
              <button
                *ngIf="!editing"
                pButton
                pRipple
                type="button"
                pInitEditableRow
                icon="pi pi-pencil"
                (click)="onRowEditInit(topic)"
                text
                rounded
                severity="secondary"
              ></button>
              <button
                *ngIf="editing"
                pButton
                pRipple
                type="button"
                pSaveEditableRow
                icon="pi pi-check"
                (click)="onRowEditSave(topic, rowIndex)"
                text
                rounded
                severity="secondary"
              ></button>
              <button
                *ngIf="editing"
                pButton
                pRipple
                type="button"
                pCancelEditableRow
                icon="pi pi-times"
                (click)="onRowEditCancel(topic, rowIndex)"
                text
                rounded
                severity="secondary"
              ></button>
            </div>
          }
          
        </td>
        <td style="width: 3rem">
          @if (topicsActive()){
            <p-tableCheckbox severity="contrast" [value]="topic" />
          }
        </td></tr
    ></ng-template>
  </p-table>
</div>
<p-toolbar class="p-20 mt-20">
  <ng-template #start>
    <p-button
      class="pr-6"
      severity="danger"
      label="Delete"
      icon="pi pi-trash"
      outlined
      (onClick)="deleteSelectedTopics()"
      [disabled]="!selectedTopics || !selectedTopics.length || !isActive"
    />
    <p-button
      [style]="{ 'background-color': '#5861ff' }"
      label="Add new"
      icon="pi pi-plus"
      class="mr-2"
      (onClick)="openNew()"
      [disabled]="!isActive || awaitingRefresh()"
    />

    <p-button
      [style]="{ 'margin-left': '.5em' }"
      [disabled]="!(changedRows().length || addedRows().length || deletedRows().length || tableStatusChanged() ) || awaitingRefresh()"
      severity="success"
      label="Save Changes"
      icon="pi pi-check"
      (click)="saveChanges()"
    ></p-button>
  </ng-template>
  <ng-template #end>
    @if (changedRows().length > 0){
      <p-tag [severity]="changedRows().length > 0 ? 'warn' : 'info'">
        {{ changedRows().length }} row(s) edited
      </p-tag>
    }

    @if (deletedRowsCount() > 0){
      <p-tag [severity]="deletedRowsCount() > 0 ? 'danger' : 'info'">
        {{ deletedRowsCount() }} row(s) deleted
      </p-tag>
    }
    
    @if (addedRows().length > 0){
    <p-tag [severity]="addedRows().length > 0 ? 'success' : 'info'" class="ml-2">
      {{ addedRows().length }} row(s) added
    </p-tag>
  }
    <span class="font-semibold"> </span>
  </ng-template>
</p-toolbar>
}
<p-dialog
  [style]="{ color: '#5861ff' }"
  [visible]="addNewRowDialog()"
  [style]="{ width: '450px' }"
  header="New Topic Classification"
  [modal]="true"
>
  <ng-template #content>
    <div class="flex flex-col gap-6">
      <div>
        <label for="topic" class="block font-bold mb-3">Class</label>
        <input
          type="text"
          pInputText
          id="name"
          [(ngModel)]="class"
          required
          autofocus
          fluid
        />
        <small
          style="color: #ff7193"
          *ngIf="submitted() && !newTopicClassification().topic"
          ><b>Class is required.</b></small
        >
      </div>
      <div>
        <label for="Definition_Gr" class="block font-bold mb-3"
          >Definition (Gr)</label
        >
        <textarea
          id="Definition_Gr"
          pTextarea
          required
          rows="3"
          cols="20"
          fluid
          #text2
        ></textarea>
        <small
          style="color: #ff7193"
          *ngIf="
            submitted() &&
            newTopicClassification()?.gr_definition == ''
          "
          ><b>Definition (Gr) is required.</b></small
        >
      </div>
      <div>
        <label for="Definition_En" class="block font-bold mb-3"
          >Definition (En)</label
        >
        <textarea
          id="Definition_En"
          pTextarea
          required
          rows="3"
          cols="20"
          fluid
          #text3
        ></textarea>
        <small
          style="color: #ff7193"
          *ngIf="
            submitted() &&
            newTopicClassification()?.en_definition == ''
          "
          ><b>Definition (En) is required.</b></small>
      </div>
    </div>
  </ng-template>

  <ng-template #footer>
    <p-button
      [style]="{ color: '#ff7193' }"
      severity="contrast"
      label="Cancel"
      icon="pi pi-times"
      text
      (click)="hideDialog()"
    />
    <p-button
      [style]="{ 'background-color': '#5861ff' }"
      label="Save"
      icon="pi pi-check"
      (click)="saveRow()"
    ></p-button>
  </ng-template>
</p-dialog>
<p-confirmdialog />
<p-toast />
